export default __webpack_public_path__ + "static/media/divider-yoga.2853db86.svg";